// Author Lin
// Date 2021-11-15 10:59:33

class MintalMesPrdSmeltingPreheatingKiln {
        constructor({
                id = null,
                locationId = '',
                locationName = '',
                productionTime = '',
                shiftId = '',
                shiftName = '',
                furnaceId = '',
                furnaceName = '',
                operatingPower = '',
                gasMaterialRatio = '',
                preTemp = '',
                afterTemp = '',
                coVolume = '',
                coPressure = '',
                coPipePressure1 = '',
                coPipePressure2 = '',
                coPower = '',
                coVibration = '',
                valveOpening = '',
                oxVolume = '',
                oxPressure = '',
                oxPipePressure1 = '',
                oxPipePressure2 = '',
                oxPower = '',
                oxVibration = '',
                circPressure = '',
                circPressureDiff = '',
                circOpening = '',
                fanNumber = '',
                fanMaxVibration = '',
                fanPower = '',
                heatCo = '',
                heatO2 = '',
                heatCo2 = '',
                gasTemp = '',
                circCo = '',
                circO2 = '',
                circCo2 = '',
                vaStatus = '',
                faStatus = '',
                mixingAvgTemp = '',
                preheatingPressure = '',
                exhaustTempOne = '',
                exhaustTempTwo = '',
                dedustingWaterPressure = '',
                dedustingWaterFlow = '',
                headTempOne = '',
                headTempTwo = '',
                headTempThree = '',
                headTempFour = '',
                headTempFive = '',
                headTempSix = '',
                headTempSeven = '',
                headTempEight = '',
                headTempNine = '',
                bottomTempOne = '',
                bottomTempTwo = '',
                bottomTempThree = '',
                bottomTempFour = '',
                bottomTempFive = '',
                bottomTempSix = '',
                bottomTempSeven = '',
                bottomTempEight = '',
                bottomTempNine = '',
                pipeTempOne = '',
                pipeTempTwo = '',
                pipeTempThree = '',
                pipeTempFour = '',
                pipeTempFive = '',
                pipeTempSix = '',
                pipeTempSeven = '',
                pipeTempEight = '',
                pipeTempNine = '',
                hotGasTempOne = '',
                hotGasTempTwo = '',
                hotGasTempThree = '',
                hotGasTempFour = '',
                hotGasTempFive = '',
                hotGasTempSix = '',
                hotGasTempSeven = '',
                hotGasTempEight = '',
                hotGasTempNine = '',
                remark = ''}
        = {}) {
            this.id = id;
            this.locationId = locationId;
            this.locationName = locationName;
            this.productionTime = productionTime;
            this.shiftId = shiftId;
            this.shiftName = shiftName;
            this.furnaceId = furnaceId;
            this.furnaceName = furnaceName;
            this.operatingPower = operatingPower;
            this.gasMaterialRatio = gasMaterialRatio;
            this.preTemp = preTemp;
            this.afterTemp = afterTemp;
            this.coVolume = coVolume;
            this.coPressure = coPressure;
            this.coPipePressure1 = coPipePressure1;
            this.coPipePressure2 = coPipePressure2;
            this.coPower = coPower;
            this.coVibration = coVibration;
            this.valveOpening = valveOpening;
            this.oxVolume = oxVolume;
            this.oxPressure = oxPressure;
            this.oxPipePressure1 = oxPipePressure1;
            this.oxPipePressure2 = oxPipePressure2;
            this.oxPower = oxPower;
            this.oxVibration = oxVibration;
            this.circPressure = circPressure;
            this.circPressureDiff = circPressureDiff;
            this.circOpening = circOpening;
            this.fanNumber = fanNumber;
            this.fanMaxVibration = fanMaxVibration;
            this.fanPower = fanPower;
            this.heatCo = heatCo;
            this.heatO2 = heatO2;
            this.heatCo2 = heatCo2;
            this.gasTemp = gasTemp;
            this.circCo = circCo;
            this.circO2 = circO2;
            this.circCo2 = circCo2;
            this.vaStatus = vaStatus;
            this.faStatus = faStatus;
            this.mixingAvgTemp = mixingAvgTemp;
            this.preheatingPressure = preheatingPressure;
            this.exhaustTempOne = exhaustTempOne;
            this.exhaustTempTwo = exhaustTempTwo;
            this.dedustingWaterPressure = dedustingWaterPressure;
            this.dedustingWaterFlow = dedustingWaterFlow;
            this.headTempOne = headTempOne;
            this.headTempTwo = headTempTwo;
            this.headTempThree = headTempThree;
            this.headTempFour = headTempFour;
            this.headTempFive = headTempFive;
            this.headTempSix = headTempSix;
            this.headTempSeven = headTempSeven;
            this.headTempEight = headTempEight;
            this.headTempNine = headTempNine;
            this.bottomTempOne = bottomTempOne;
            this.bottomTempTwo = bottomTempTwo;
            this.bottomTempThree = bottomTempThree;
            this.bottomTempFour = bottomTempFour;
            this.bottomTempFive = bottomTempFive;
            this.bottomTempSix = bottomTempSix;
            this.bottomTempSeven = bottomTempSeven;
            this.bottomTempEight = bottomTempEight;
            this.bottomTempNine = bottomTempNine;
            this.pipeTempOne = pipeTempOne;
            this.pipeTempTwo = pipeTempTwo;
            this.pipeTempThree = pipeTempThree;
            this.pipeTempFour = pipeTempFour;
            this.pipeTempFive = pipeTempFive;
            this.pipeTempSix = pipeTempSix;
            this.pipeTempSeven = pipeTempSeven;
            this.pipeTempEight = pipeTempEight;
            this.pipeTempNine = pipeTempNine;
            this.hotGasTempOne = hotGasTempOne;
            this.hotGasTempTwo = hotGasTempTwo;
            this.hotGasTempThree = hotGasTempThree;
            this.hotGasTempFour = hotGasTempFour;
            this.hotGasTempFive = hotGasTempFive;
            this.hotGasTempSix = hotGasTempSix;
            this.hotGasTempSeven = hotGasTempSeven;
            this.hotGasTempEight = hotGasTempEight;
            this.hotGasTempNine = hotGasTempNine;
            this.remark = remark;
        }
        }
        
        function newEntity() {
        return new MintalMesPrdSmeltingPreheatingKiln();
        }
        
            function gridFields() {
            return Object.freeze([
                {
                key: 'id',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.id',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.locationId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.locationName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'productionTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.productionTime',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.shiftId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.shiftName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceId',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.furnaceId',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.furnaceName',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'operatingPower',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.operatingPower',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'gasMaterialRatio',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.gasMaterialRatio',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'preTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.preTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'afterTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.afterTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coVolume',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.coVolume',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.coPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coPipePressure1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.coPipePressure1',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coPipePressure2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.coPipePressure2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coPower',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.coPower',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'coVibration',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.coVibration',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'valveOpening',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.valveOpening',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'oxVolume',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.oxVolume',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'oxPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.oxPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'oxPipePressure1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.oxPipePressure1',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'oxPipePressure2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.oxPipePressure2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'oxPower',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.oxPower',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'oxVibration',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.oxVibration',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'circPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.circPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'circPressureDiff',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.circPressureDiff',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'circOpening',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.circOpening',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'fanNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.fanNumber',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'fanMaxVibration',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.fanMaxVibration',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'fanPower',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.fanPower',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'heatCo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.heatCo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'heatO2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.heatO2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'heatCo2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.heatCo2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'gasTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.gasTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'circCo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.circCo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'circO2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.circO2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'circCo2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.circCo2',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'vaStatus',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.vaStatus',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'faStatus',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.faStatus',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'mixingAvgTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.mixingAvgTemp',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'preheatingPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.preheatingPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'exhaustTempOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.exhaustTempOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'exhaustTempTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.exhaustTempTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dedustingWaterPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.dedustingWaterPressure',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'dedustingWaterFlow',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.dedustingWaterFlow',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'headTempOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.headTempOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'headTempTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.headTempTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'headTempThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.headTempThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'headTempFour',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.headTempFour',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'headTempFive',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.headTempFive',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'headTempSix',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.headTempSix',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'headTempSeven',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.headTempSeven',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'headTempEight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.headTempEight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'headTempNine',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.headTempNine',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bottomTempOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.bottomTempOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bottomTempTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.bottomTempTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bottomTempThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.bottomTempThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bottomTempFour',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.bottomTempFour',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bottomTempFive',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.bottomTempFive',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bottomTempSix',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.bottomTempSix',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bottomTempSeven',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.bottomTempSeven',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bottomTempEight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.bottomTempEight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'bottomTempNine',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.bottomTempNine',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pipeTempOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.pipeTempOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pipeTempTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.pipeTempTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pipeTempThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.pipeTempThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pipeTempFour',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.pipeTempFour',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pipeTempFive',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.pipeTempFive',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pipeTempSix',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.pipeTempSix',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pipeTempSeven',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.pipeTempSeven',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pipeTempEight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.pipeTempEight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'pipeTempNine',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.pipeTempNine',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'hotGasTempOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.hotGasTempOne',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'hotGasTempTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.hotGasTempTwo',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'hotGasTempThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.hotGasTempThree',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'hotGasTempFour',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.hotGasTempFour',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'hotGasTempFive',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.hotGasTempFive',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'hotGasTempSix',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.hotGasTempSix',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'hotGasTempSeven',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.hotGasTempSeven',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'hotGasTempEight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.hotGasTempEight',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'hotGasTempNine',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.hotGasTempNine',
                sortable: true,
                form: {
                type: 'input'
                }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.grid.remark',
                sortable: true,
                    isDetail: true,
                form: {
                type: 'textarea'
                }
                }
            ])}
        
        const filter = {
            idFilter : '',
            idListFilter : [],
            locationIdFilter : '',
            locationNameFilter : '',
            productionTimeRteFilter : '',
            productionTimeLteFilter : '',
            shiftIdFilter : '',
            shiftNameFilter : '',
            furnaceIdFilter : '',
            furnaceNameFilter : '',
            operatingPowerFilter : '',
            gasMaterialRatioFilter : '',
            preTempFilter : '',
            afterTempFilter : '',
            coVolumeFilter : '',
            coPressureFilter : '',
            coPipePressure1Filter : '',
            coPipePressure2Filter : '',
            coPowerFilter : '',
            coVibrationFilter : '',
            valveOpeningFilter : '',
            oxVolumeFilter : '',
            oxPressureFilter : '',
            oxPipePressure1Filter : '',
            oxPipePressure2Filter : '',
            oxPowerFilter : '',
            oxVibrationFilter : '',
            circPressureFilter : '',
            circPressureDiffFilter : '',
            circOpeningFilter : '',
            fanNumberFilter : '',
            fanMaxVibrationFilter : '',
            fanPowerFilter : '',
            heatCoFilter : '',
            heatO2Filter : '',
            heatCo2Filter : '',
            gasTempFilter : '',
            circCoFilter : '',
            circO2Filter : '',
            circCo2Filter : '',
            vaStatusFilter : '',
            faStatusFilter : '',
            mixingAvgTempFilter : '',
            preheatingPressureFilter : '',
            exhaustTempOneFilter : '',
            exhaustTempTwoFilter : '',
            dedustingWaterPressureFilter : '',
            dedustingWaterFlowFilter : '',
            headTempOneFilter : '',
            headTempTwoFilter : '',
            headTempThreeFilter : '',
            headTempFourFilter : '',
            headTempFiveFilter : '',
            headTempSixFilter : '',
            headTempSevenFilter : '',
            headTempEightFilter : '',
            headTempNineFilter : '',
            bottomTempOneFilter : '',
            bottomTempTwoFilter : '',
            bottomTempThreeFilter : '',
            bottomTempFourFilter : '',
            bottomTempFiveFilter : '',
            bottomTempSixFilter : '',
            bottomTempSevenFilter : '',
            bottomTempEightFilter : '',
            bottomTempNineFilter : '',
            pipeTempOneFilter : '',
            pipeTempTwoFilter : '',
            pipeTempThreeFilter : '',
            pipeTempFourFilter : '',
            pipeTempFiveFilter : '',
            pipeTempSixFilter : '',
            pipeTempSevenFilter : '',
            pipeTempEightFilter : '',
            pipeTempNineFilter : '',
            hotGasTempOneFilter : '',
            hotGasTempTwoFilter : '',
            hotGasTempThreeFilter : '',
            hotGasTempFourFilter : '',
            hotGasTempFiveFilter : '',
            hotGasTempSixFilter : '',
            hotGasTempSevenFilter : '',
            hotGasTempEightFilter : '',
            hotGasTempNineFilter : ''
        };
        
        const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));
        
        const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));
        
        const filterConfigs = [
                {
                key: 'locationNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.filter.locationName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'productionTimeRteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.filter.productionTimeRte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'productionTimeLteFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.filter.productionTimeLte',
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'shiftNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.filter.shiftName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
                {
                key: 'furnaceNameFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.filter.furnaceName',
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'fanNumberFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.filter.fanNumber',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'vaStatusFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.filter.vaStatus',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'faStatusFilter',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.filter.faStatus',
                disabled: false,
                form: {
                type: 'input'
                        }
                },
        ];
        
        
            const entityFormConfigs = [
                {
                key: 'locationName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.locationName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstLocation'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"locationId":"id"}'
                        }
                },
                {
                key: 'productionTime',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.productionTime',
                sortable: true,
                disabled: false,
                form: {
                type: 'datetimepicker'
                        }
                },
                {
                key: 'shiftName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.shiftName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'imfMstShift'
                    ,correspondingField: 'name'
                    ,fieldsBindingByEntityModalSelected: '{"shiftId":"id"}'
                        }
                },
                {
                key: 'furnaceName',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.furnaceName',
                sortable: true,
                disabled: false,
                form: {
                type: 'entityModalSelect'
                    ,entity: 'mintalMesMstFurnace'
                    ,correspondingField: 'furnaceName'
                    ,fieldsBindingByEntityModalSelected: '{"furnaceId":"id"}'
                        }
                },
                {
                key: 'operatingPower',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.operatingPower',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'gasMaterialRatio',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.gasMaterialRatio',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'preTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.preTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'afterTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.afterTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coVolume',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.coVolume',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.coPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coPipePressure1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.coPipePressure1',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coPipePressure2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.coPipePressure2',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coPower',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.coPower',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'coVibration',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.coVibration',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'valveOpening',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.valveOpening',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'oxVolume',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.oxVolume',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'oxPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.oxPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'oxPipePressure1',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.oxPipePressure1',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'oxPipePressure2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.oxPipePressure2',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'oxPower',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.oxPower',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'oxVibration',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.oxVibration',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'circPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.circPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'circPressureDiff',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.circPressureDiff',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'circOpening',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.circOpening',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'fanNumber',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.fanNumber',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'fanMaxVibration',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.fanMaxVibration',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'fanPower',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.fanPower',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heatCo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.heatCo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heatO2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.heatO2',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'heatCo2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.heatCo2',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'gasTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.gasTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'circCo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.circCo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'circO2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.circO2',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'circCo2',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.circCo2',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'vaStatus',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.vaStatus',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'faStatus',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.faStatus',
                sortable: true,
                disabled: false,
                form: {
                type: 'input'
                        }
                },
                {
                key: 'mixingAvgTemp',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.mixingAvgTemp',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'preheatingPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.preheatingPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'exhaustTempOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.exhaustTempOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'exhaustTempTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.exhaustTempTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dedustingWaterPressure',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.dedustingWaterPressure',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'dedustingWaterFlow',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.dedustingWaterFlow',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'headTempOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.headTempOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'headTempTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.headTempTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'headTempThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.headTempThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'headTempFour',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.headTempFour',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'headTempFive',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.headTempFive',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'headTempSix',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.headTempSix',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'headTempSeven',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.headTempSeven',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'headTempEight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.headTempEight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'headTempNine',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.headTempNine',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bottomTempOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.bottomTempOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bottomTempTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.bottomTempTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bottomTempThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.bottomTempThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bottomTempFour',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.bottomTempFour',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bottomTempFive',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.bottomTempFive',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bottomTempSix',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.bottomTempSix',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bottomTempSeven',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.bottomTempSeven',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bottomTempEight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.bottomTempEight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'bottomTempNine',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.bottomTempNine',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pipeTempOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.pipeTempOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pipeTempTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.pipeTempTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pipeTempThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.pipeTempThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pipeTempFour',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.pipeTempFour',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pipeTempFive',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.pipeTempFive',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pipeTempSix',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.pipeTempSix',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pipeTempSeven',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.pipeTempSeven',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pipeTempEight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.pipeTempEight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'pipeTempNine',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.pipeTempNine',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'hotGasTempOne',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.hotGasTempOne',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'hotGasTempTwo',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.hotGasTempTwo',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'hotGasTempThree',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.hotGasTempThree',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'hotGasTempFour',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.hotGasTempFour',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'hotGasTempFive',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.hotGasTempFive',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'hotGasTempSix',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.hotGasTempSix',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'hotGasTempSeven',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.hotGasTempSeven',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'hotGasTempEight',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.hotGasTempEight',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'hotGasTempNine',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.hotGasTempNine',
                sortable: true,
                disabled: false,
                form: {
                type: 'inputNumber'
                        }
                },
                {
                key: 'remark',
                label: 'label.mintal.prd.mintalMesPrdSmeltingPreheatingKiln.entity.remark',
                sortable: true,
                disabled: false,
                form: {
                type: 'textarea'
                        }
                }
        ]
        
        export {MintalMesPrdSmeltingPreheatingKiln, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
        , filterConfigs
        
        
        }
        